module.exports = __webpack_public_path__ + "img/infTricycleJour.cedad012.webp";